import React from 'react';
import { Box, BoxProps } from '@/components/base/box';
import { applyOpacity, theme } from '@/assets/theme';
import { useTheme } from 'styled-components/native';

interface Props extends BoxProps {
  shadowOffsetX?: number;
  shadowOffsetY?: number;
  blurRadius?: number;
  shadowColor?: string;
  shadowOpacity?: number;
  variant?: 'soft-green';
}

function BaseAppCardView({
  style,
  shadowOffsetX = 1,
  shadowOffsetY = 1,
  blurRadius = 6,
  shadowColor,
  shadowOpacity = 1, // Defaulting to 100% if omitted
  variant,
  ...rest
}: Props) {
  const theme = useTheme();

  if (variant === 'soft-green') {
    return (
      <Box
        {...rest}
        style={[
          { backgroundColor: 'white', borderColor: applyOpacity(theme.colors.jadeDark, 0.1), borderWidth: 0.5 },
          generateShadow({ shadowColor: theme.colors.jadeDark, blurRadius: 10, shadowOpacity: 0.08, shadowOffsetX: 0, shadowOffsetY: 4 }),
          style,
        ]}
      />
    );
  }
  return <Box {...rest} style={[{ backgroundColor: 'white' }, generateShadow({ blurRadius, shadowOpacity, shadowColor, shadowOffsetX, shadowOffsetY }), style]} />;
}

export const AppCardView = React.memo(BaseAppCardView);

export function generateShadow({
  blurRadius,
  shadowOffsetY,
  shadowOpacity,
  shadowOffsetX,
  shadowColor,
}: {
  shadowOffsetX: number;
  shadowOffsetY: number;
  blurRadius: number;
  shadowOpacity: number;
  shadowColor?: string;
}) {
  const baseColor = shadowColor || theme.colors.shadow;
  // 1. Combine the color and opacity safely
  const finalShadowColor = applyOpacity(baseColor, shadowOpacity);

  return {
    boxShadow: [
      {
        offsetX: shadowOffsetX,
        offsetY: shadowOffsetY,
        blurRadius: blurRadius,
        color: finalShadowColor, // 2. Pass the combined alpha color here
      },
    ],
  } as any;
}
